<div style="width: 100%" *ngIf="updates > 0">
  <div style="text-align: center">{{ progressStr }}</div>
  <mat-progress-bar [mode]="mode" [value]="progress"></mat-progress-bar>
  <div class="row-layout justify-content-flex-end">
    <div
      *ngIf="loaded.length > 1 && total.length > 1"
      style="text-align: center; flex: 1"
    >
      {{ loaded }} / {{ total }}
    </div>
    <div *ngIf="showTime">Zeit: {{ time }}</div>
  </div>
</div>
